<template>
  <div
    :data-scroll-speed="scrollSpeed"
    data-scroll-delay="0.1"
    class="c-button"
    @click="onClick"
    v-ga="isShopButton ? $ga.commands.trackStoreClick.bind(this, 1) : null"
  >
    <span class="label" :style="{ color: labelColor }">{{ label }}</span>
    <svg
      width="390"
      height="193"
      viewBox="0 0 390 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="button-layer"
    >
      <g class="main-rect" :filter="`url(#filter_${labelColor})`">
        <path
          d="M45 47.9169H359L343 109.917H29L45 47.9169Z"
          :fill="buttonColor"
        />
      </g>
      <g class="tri left" :filter="`url(#filter_${labelColor})`">
        <path
          d="M118 40.9171L37 42.417L24 76.7789L118 40.9171Z"
          :fill="buttonColor"
        />
      </g>
      <g class="tri right" :filter="`url(#filter_${labelColor})`">
        <path
          d="M225 130.128L353.445 125.282L365.479 90.5699L225 130.128Z"
          :fill="buttonColor"
        />
      </g>
      <defs>
        <filter
          :id="`filter_${labelColor}`"
          x="7"
          y="25.9169"
          width="374"
          height="106"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: 'オンラインストアで購入' },
    isShopButton: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'red',
      validator: function(value) {
        return ['white', 'red'].indexOf(value) !== -1
      }
    },
    scrollSpeed: {
      type: String,
      default: '0'
    },

    onClick: {
      type: Function,
      default: () => {
        return false
      }
    }
  },

  data() {
    return {
      hover: false
    }
  },
  computed: {
    buttonColor() {
      return this.color === 'white' ? '#fff' : '#e40718'
    },
    labelColor() {
      return this.color === 'white' ? '#e40718' : '#fff'
    }
  },

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.c-button {
  position: relative;
  width: 50rem;
  height: 14rem;
  margin: 0 auto;
  cursor: pointer;
  z-index: 0;
  @media screen and (max-width: $breakpoint-mobile) {
    max-width: 50rem;
    width: 100%;
    height: 10rem;
  }
  .label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-weight: 700;
    font-size: 1.8rem;
    @media screen and (max-width: $breakpoint-mobile) {
      font-size: 1.8rem;
      width: 100%;
    }
  }
  .button-layer {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, calc(-50% + 0.8rem));
    z-index: -9;
    pointer-events: none;

    .main-rect {
      transform: scale(1);
      transform-origin: center;
      transition: transform 0.65s $ease;
    }

    .tri {
      transform: rotate(0deg) skew(0deg, 0deg);
      transition: transform 0.65s $ease;
    }
  }

  @media screen and (min-width: 751px) {
    &:hover {
      .main-rect {
        transform: scale(0.95);
        transform-origin: center;
      }

      .tri {
        &.left {
          transform: rotate(4deg) skew(0deg, -12deg);
        }
        &.right {
          transform: rotate(-10deg) skew(0deg, 12deg);
          transform-origin: 0 0;
        }
      }
    }
  }
}
</style>
